import React from 'react';

/**
 * Keyboard-accessible "skip to content" link. Hidden until focused.
 * Pair with <main id="main"> elsewhere.
 */
export function SkipLink({ targetId = 'main' }: { targetId?: string }) {
  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[9999] focus:rounded-md focus:bg-brand-700 focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-white focus:shadow-modal"
    >
      Skip to main content
    </a>
  );
}

export default SkipLink;
